import {
  matchPath,
  type ShouldRevalidateFunction,
  type ShouldRevalidateFunctionArgs
} from 'react-router-dom';

/** Artifact selection is local workspace state; it does not change any route loader's input. */
export const isWorkspaceArtifactNavigation = ({
  currentUrl,
  nextUrl,
  formMethod
}: ShouldRevalidateFunctionArgs): boolean => {
  if (
    (formMethod && formMethod !== 'GET') ||
    currentUrl.pathname !== nextUrl.pathname ||
    !matchPath('/app/workspaces/:id', nextUrl.pathname) ||
    currentUrl.search === nextUrl.search
  )
    return false;

  const withoutSelection = (url: URL) => {
    const search = new URLSearchParams(url.search);
    search.delete('artifact_id');
    search.delete('version');
    search.sort();
    return search.toString();
  };
  return withoutSelection(currentUrl) === withoutSelection(nextUrl);
};

export const shouldRevalidateWorkspace: ShouldRevalidateFunction = (args) =>
  !isWorkspaceArtifactNavigation(args) && args.defaultShouldRevalidate;
